module.exports = __webpack_public_path__ + "img/buildakeyboard.ac3b0614.png";